import { render } from "./MembersTable.vue?vue&type=template&id=2fa4de5d"
import script from "./MembersTable.vue?vue&type=script&lang=js"
export * from "./MembersTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__